import AWS from "aws-sdk";

// CURRENTLY COMMENTING THIS IN ORDER NOT TO FORGET IN CASE WE WILL BE REVIVING THIS PROJECT THAT WE WILL BE USING PRESIGNED URLS INSTEAD OF AWS SDK
// DO NOT USE THIS ANYMORE
// WE MUST IMPLEMENT THE USE OF PRESIGNED URLS
// THIS CAUSES EVERYTHING TO BREAK

const awsconfig = {
    // aws_project_region: process.env.REACT_APP_REGION,
    // aws_cognito_region: process.env.REACT_APP_REGION,
    // // TO DO: Must be changed to the web client id
    // aws_user_pools_id: process.env.REACT_APP_USER_POOL_ID,
    // // TO DO: Must be changed
    // aws_user_pools_web_client_id: process.env.REACT_APP_USER_POOL_CLIENT_ID,
    // aws_storage_bucket: process.env.REACT_APP_S3_BUCKET,
    // aws_storage_region: process.env.REACT_APP_REGION,
    // aws_access_key_id: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    // aws_secret_access_key: process.env.REACT_APP_AWS_ACCESS_KEY,
};

// AWS.config.update({
//     accessKeyId: awsconfig.aws_access_key_id,
//     secretAccessKey: awsconfig.aws_secret_access_key,
// });

export default awsconfig;
